/*
 * Copyright (C) 2023 to Present Applause App Quality, Inc. All rights reserved.
 */

import { Directive, ElementRef, Input, OnChanges, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { $SimpleChanges } from '@ng-falcon/+legacy/+model/on-changes/simple-changes';
import { TemplateWithContext } from '@ng-falcon/ngf-tooltip/ngf-tooltip-content/ngf-tooltip-content';
import { NgfTooltipService } from '@ng-falcon/ngf-tooltip/ngf-tooltip.service';

@Directive({
  selector: '[ngfTooltip]',
  standalone: true
})
export class NgfTooltipDirective implements OnInit, OnChanges, OnDestroy {

  @Input('ngfTooltip')
  content: string | TemplateRef<any> | TemplateWithContext<any> | null;
  @Input('ngfTooltipDisabled')
  disabled = false;
  @Input('ngfTooltipMaxWidth')
  maxWidth: string | null = null;
  @Input('ngfTooltipTextAlign')
  textAlign: string | null = null;

  constructor(private elementRef: ElementRef<HTMLElement>,
              private vcr: ViewContainerRef,
              private tooltip: NgfTooltipService) {}

  ngOnInit(): void {
    if (!this.disabled) {
      this.createTooltip();
    }
  }

  ngOnChanges(changes: $SimpleChanges<this>): void {
    if (changes.disabled && !changes.disabled.firstChange) {
      if (!this.disabled) {
        this.createTooltip();
      } else {
        this.destroyTooltip();
      }
    }
  }

  ngOnDestroy(): void {
    this.destroyTooltip();
  }

  private createTooltip(): void {
    this.tooltip.create(this.elementRef, {
      vcr: this.vcr,
      content: () => this.content,
      styles: () => ({ maxWidth: this.maxWidth, textAlign: this.textAlign }),
      canOpen: () => this.content !== null && this.content !== undefined && this.content !== '',
    });
  }

  private destroyTooltip(): void {
    this.tooltip.destroy(this.elementRef);
  }

}
